import { Garage } from './ui/Garage'

export default Garage